import React from "react";
import {
  Box,
  Table,
  Badge,
  Text,
  Menu,
  Divider,
  createStyles,
  Button,
  Tooltip,
  Popover,
} from "@mantine/core";
import ButtonSvg from "../assets/img/more.svg";
import deleteIcon from "../assets/img/deleteIConeligibility.svg";
import cancel from "../assets/img/reschdule.svg";
import reschdule from "../assets/img/cancel.svg";
import { getStatusColor, gettextcolor } from "../utils";
import jsonIcon from "../assets/img/json-file-icon 1.svg";
import documentIcon from "../assets/img/doc.svg";
import refreshIcon from "../assets/img/refresh.svg";

interface TableProps {
  head: string[];
  data: { [key: string]: string | JSX.Element }[];
  showActionColumn?: boolean;
  showActionColumnForEligibility?: boolean;
  handleClick?: any;
  isDetails?: boolean;
  handleDetails?: any;
  handleRefresh?: any;
  excludeColumns?: string[]; // Add this prop to exclude specific columns

  handleStartCall?: (
    patientId: string,
    url: string,
    appointmentId: string,
    Status: string
  ) => void;
  handleFhir?: (patientId: string, appointmentId: string) => void;
}

export const CustomTable: React.FC<TableProps> = ({
  head,
  data,
  showActionColumn,
  handleStartCall,
  handleClick,
  handleFhir,
  isDetails,
  handleDetails,
  handleRefresh,
  showActionColumnForEligibility,
  excludeColumns,
}) => {
  const useStyles = createStyles(() => ({
    menuitem1: {
      display: "flex",
      alignItems: "center",
      width: "183px",
      height: "43px",
      fontWeight: 600,
      fontSize: "14px",
      justifyContent: "flex-start",
      paddingLeft: "22px",
    },
    menutarget: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "10px",
      cursor: "pointer",
    },
    menuitem2: {
      display: "flex",
      alignItems: "center",
      width: "183px",
      height: "43px",
      fontWeight: 600,
      fontSize: "14px",
      justifyContent: "flex-start",
      paddingLeft: "22px",
    },
    th: {
      height: "58px",
      backgroundColor: "#BEDEF8",
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "21px",
      color: "#262930",
    },
    box: { width: "30px", display: "flex", justifyContent: "center" },
  }));
  const { classes } = useStyles();

  const rows = data.map((rowData, index) => (
    <tr
      key={index}
      onClick={() => handleClick && handleClick(rowData)}
      style={{ cursor: "pointer" }}
    >
      {Object.entries(rowData).map(([key, value]) => (
        <td key={key} style={{ height: "58px" }}>
          {key === "Status" ? (
            <Badge
              sx={{
                borderRadius: "4px",
                height: "30px",
                width: "100px",
                "&.mantine-Badge-root": {
                  backgroundColor: getStatusColor(value as string),
                  color: gettextcolor(value as string),
                },
              }}
            >
              <Text>{value}</Text>
            </Badge>
          ) : key === "outComeDesc" ? (
            <Box w={300}>
              <Popover width={500} position="bottom" withArrow shadow="md">
                <Popover.Target>
                  <Text truncate="end">{value}</Text>
                </Popover.Target>
                <Popover.Dropdown sx={{ overflowY: "auto", maxHeight: "500" }}>
                  <Text size="lg">{value}</Text>
                </Popover.Dropdown>
              </Popover>
            </Box>
          ) : key === "outcome" ? (
            <Badge
              sx={{
                borderRadius: "4px",
                height: "30px",
              }}
              color={
                value === "0"
                  ? "green"
                  : value === "12"
                  ? "red"
                  : value === "4"
                  ? "red"
                  : value === "8"
                  ? "red"
                  : ""
              }
            >
              <Text>
                {value === "0"
                  ? "SUCCESS"
                  : value === "12"
                  ? "MAJOR FAILURE"
                  : value === "4"
                  ? "MINOR FAILURE"
                  : value === "8"
                  ? "SERIOUS FAILURE"
                  : value}
              </Text>
            </Badge>
          ) : key === "Call" ? (
            <Button
              onClick={() =>
                handleStartCall &&
                handleStartCall(
                  (value as any)?.patientId,
                  (value as any).callUrl,
                  (value as any).appointmentId,
                  (rowData as any).Status
                )
              }
              sx={{
                backgroundColor: (value as any)?.callUrl ? "3F8BC7" : "#8dbee5",
              }}
            >
              Start Call
            </Button>
          ) : key === "Appointment note" ? (
            value?.toString()?.length > 20 ? (
              <Tooltip label={value} color="grey">
                <span>{value?.toString().slice(0, 20) + "..."}</span>
              </Tooltip>
            ) : (
              value
            )
          ) : key === "Eligibility" ? (
            (rowData[key] as any).outcome === "complete" ? (
              <Button
                onClick={() => handleDetails(rowData as any)}
                variant="outline"
                sx={{ fontWeight: 600, fontSize: "12px", lineHeight: "20px" }}
              >
                <img
                  src={documentIcon}
                  style={{ marginRight: "8px" }}
                  alt="docIcon"
                />
                Details
              </Button>
            ) : (
              <Button
                onClick={handleRefresh(rowData as any)}
                variant="outline"
                sx={{ fontWeight: 600, fontSize: "12px", lineHeight: "20px" }}
              >
                <img
                  src={refreshIcon}
                  style={{ marginRight: "8px" }}
                  alt="refrshIcon"
                />
                Refresh
              </Button>
            )
          ) : key === "view" ? (
            <Button variant="outline" size="sm">
              View
            </Button>
          ) : (
            <Box w={150}>
              <Popover width={400} position="bottom" withArrow shadow="md">
                <Popover.Target>
                  <Text truncate="end">{value}</Text>
                </Popover.Target>
                <Popover.Dropdown sx={{ overflowY: "auto", maxHeight: "500" ,display:'flex',justifyContent:"center"}}>
                  <Text size="lg">{value}</Text>
                </Popover.Dropdown>
              </Popover>
            </Box>
          )}
        </td>
      ))}
      {showActionColumn && (
        <td style={{ display: "flex", justifyContent: "center" }}>
          <Menu>
            <Menu.Target>
              <Box className={classes.box}>
                <img src={ButtonSvg} className={classes.menutarget} />
              </Box>
            </Menu.Target>
            <Menu.Dropdown
              sx={{
                borderRadius: "8px",
                transform: "translateX(calc(100% - 309px))",
              }}
            >
              <Menu.Item component="a">
                <Box className={classes.menuitem1}>
                  <Box sx={{ paddingRight: "20px" }}>
                    <img src={reschdule} />
                  </Box>
                  Re-schedule
                </Box>
              </Menu.Item>
              <Divider />
              <Menu.Item>
                <Box className={classes.menuitem2}>
                  <Box sx={{ paddingRight: "20px" }}>
                    <img src={cancel} />
                  </Box>{" "}
                  Cancel
                </Box>
              </Menu.Item>
              <Divider />
              <Menu.Item>
                <Box
                  className={classes.menuitem1}
                  onClick={() => {
                    const rowData = data[index];
                    handleFhir &&
                      handleFhir(
                        (rowData as any)?.Call?.patientId,
                        (rowData as any)?.Call?.appointmentId
                      );
                  }}
                >
                  <Box sx={{ paddingRight: "20px" }}>
                    <img src={jsonIcon} width={"20px"} />
                  </Box>{" "}
                  FHIR Response
                </Box>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </td>
      )}
      {showActionColumnForEligibility && (
        <td style={{ display: "flex", justifyContent: "center" }}>
          <Box className={classes.box}>
            <img src={deleteIcon} className={classes.menutarget} />
          </Box>
        </td>
      )}
    </tr>
  ));

  return (
    <Table>
      <thead>
        <tr>
          {head.map((columnName, index) => (
            <th
              key={index}
              className={classes.th}
              style={{
                borderTopLeftRadius: index === 0 ? "4px" : "0",
                borderBottomLeftRadius: index === 0 ? "4px" : "0",
                borderTopRightRadius:
                  index === head.length - 1 &&
                  !showActionColumn &&
                  !showActionColumnForEligibility
                    ? "4px"
                    : "0",
                borderBottomRightRadius:
                  index === head.length - 1 &&
                  !showActionColumn &&
                  !showActionColumnForEligibility
                    ? "4px"
                    : "0",
              }}
            >
              {columnName}
            </th>
          ))}

          {showActionColumn && (
            <th
              style={{
                height: "58px",
                // display: "flex",
                justifyContent: "center",
                backgroundColor: "#BEDEF8",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "21px",
                color: "#262930",
                textAlign: "center",
                borderTopRightRadius: "4px",
                borderBottomRightRadius: "4px",
              }}
            >
              Action
            </th>
          )}
          {showActionColumnForEligibility && (
            <th
              style={{
                height: "58px",
                // display: "flex",
                justifyContent: "center",
                backgroundColor: "#BEDEF8",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "21px",
                color: "#262930",
                textAlign: "center",
                borderTopRightRadius: "4px",
                borderBottomRightRadius: "4px",
              }}
            >
              Action
            </th>
          )}
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  );
};
